export default function getPhoneNumberDigits(phone: string) {
  return phone.replace(/[\D]/g, '');
}
